import * as React from "react";
import { Button } from "@/components/ui/button";
import { Trash2, X, XCircle } from "lucide-react";
import { cn } from "@/lib/utils";

/**
 * Standardized remove button component using shadcn/ui Button with color-coded icon
 * @param {Function} onClick - Click handler
 * @param {string} ariaLabel - Accessibility label (default: "Remove")
 * @param {string} variant - Button variant (default: "destructive")
 * @param {string} size - Button size: "default" | "sm" | "lg" | "icon" (default: "icon")
 * @param {string} className - Additional CSS classes
 * @param {ReactNode} children - Optional custom content (default: Trash2 icon)
 * @param {boolean} useXIcon - Use X icon instead of Trash2 (default: false)
 * @param {object} ...props - Other button props
 */
function RemoveButton({
  onClick,
  ariaLabel = "Remove",
  variant = "destructive",
  size = "icon",
  className = "",
  children,
  useXIcon = false,
  ...props
}) {
  // Determine which icon to show
  let iconToShow;
  if (children) {
    // If children is provided and it's "×" or "✕", use X icon
    if (children === "×" || children === "✕") {
      iconToShow = <X className="h-4 w-4" />;
    } else {
      iconToShow = children;
    }
  } else if (useXIcon) {
    iconToShow = <XCircle className="h-4 w-4" />;
  } else {
    iconToShow = <Trash2 className="h-4 w-4" />;
  }

  return (
    <Button
      type="button"
      onClick={onClick}
      variant={variant}
      size={size}
      className={cn(className)}
      aria-label={ariaLabel}
      {...props}
    >
      {iconToShow}
    </Button>
  );
}

export default RemoveButton;
